import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import EventPage from './components/EventPage';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentFailed from './components/PaymentFailed';
import PayInstalmentPage from './components/PayInstalmentPage';
import PaySubscriptionPage from './components/PaySubscriptionPage';
import CookieConsentBanner from './components/CookieConsentBanner';
import CookiePolicyPage from './components/CookiePolicyPage';
import { TranslationProvider } from './i18n/TranslationContext';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <TranslationProvider>
      <Router>
        <Routes>
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/failed" element={<PaymentFailed />} />
          <Route path="/pay-instalment/:token" element={<PayInstalmentPage />} />
          <Route path="/pay-subscription/:token" element={<PaySubscriptionPage />} />
          <Route path="/event/:slug" element={<EventPage />} />
          <Route path="/event/:slug/:section" element={<EventPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/" element={<EventPage />} />
        </Routes>
        <CookieConsentBanner />
      </Router>
      </TranslationProvider>
    </ThemeProvider>
  );
}

export default App;